import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { Button, Form, FormGroup, Row, Col } from 'reactstrap';

import RenderField from '../../../components/fields/RenderField';
import CustomTagSelect from '../../../components/fields/CustomTagSelect';
import SearchableSelect from '../../../components/fields/SearchableSelect';
import DatePickerField from '../../../components/fields/DatePickerField';
import CheckboxField from '../../../components/fields/CheckboxField';
import MarkingsSightedFieldArray from '../../../components/fields/MarkingsSightedFieldArray';
import { isBreakBulkJobType, isImportOrExportContainerAndMethylBromide } from 'util/JobTypeHelper';

import { preventEnterSubmit } from '../../../actions/formActions';


import { reduxForm } from 'redux-form';
import { isMethylBromide } from 'util/TreatmentTypeHelper';
const propTypes = {
  handleSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  markings: PropTypes.array,
  currentJob: PropTypes.object,
  initialValues:PropTypes.object
};

function TreatmentResultMarkingsForm({
  handleSubmit,
  currentJob,
  isSubmitting,
  initialValues,
  onSubmit
}) {
  if (!initialValues || initialValues.length === 0) return null;



  return (
    <Form onSubmit={handleSubmit(onSubmit)} onKeyPress={preventEnterSubmit}>
      <Row style={{ paddingTop: 25 }}>
        <Col xs={12}>
          <FormGroup className="col-md-12">
            <h5>Markings</h5>
          </FormGroup>
          <FormGroup className="col-md-12">
            <FieldArray
              name="markings"
              component={MarkingsSightedFieldArray}
              jobType={currentJob.type}
         
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
       { !isImportOrExportContainerAndMethylBromide(currentJob.type,currentJob.treatmentDetails.treatmentTypeId) && !(isBreakBulkJobType(currentJob.type) && isMethylBromide(currentJob.treatmentDetails.treatmentTypeId))?
        <FormGroup className="col-md-4">
          <Button type="submit" color="primary" className="mt-3" disabled={isSubmitting}>
            Save Markings
          </Button>
        </FormGroup>:null }
      </Row>
    </Form>
  );
}
/*
TreatmentResultMarkingsForm.propTypes = propTypes;
export default reduxForm({
  form: 'treatmentResultMarkingsForm',
  enableReinitialize: true, // reinitialize form when initialValues change
})(TreatmentResultMarkingsForm);*/

export default TreatmentResultMarkingsForm;
